/**
 * Bundle do módulo meta → public/x-assets/js/app.js
 */

require('./bootstrap');

import Alpine from 'alpinejs';
import sidebar from './sidebar';

window.Alpine = Alpine;

Alpine.data('sidebar', sidebar);

// O bundle é carregado sem `defer` no <head> porque os <script> inline das
// views dependem de jQuery já estar disponível. Alpine, por outro lado,
// precisa do <body> montado para varrer a árvore.
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
        Alpine.start();
    });
} else {
    Alpine.start();
}
